module.exports = require("./de-LI.d.ts");